import type { ChartComponentLike, Plugin } from 'chart.js';
import {
  /* Scales */
  CategoryScale,
  LinearScale,
  /* Elements */
  BarElement,
  PointElement,
  LineElement,
  ArcElement,
  /* Features */
  Title,
  Tooltip,
  Legend,
  Filler,
} from 'chart.js';

import { Corsair } from './corsair.ts';
import { Datalabels } from './datalabels.ts';
import { LegendStatePlugin } from './legendStatePlugin/index.ts';

/* This plugins always enabled for every chart */
export const defaultPlugins: ChartComponentLike[] = [
  CategoryScale,
  LinearScale,
  BarElement,
  PointElement,
  LineElement,
  ArcElement,
  Filler,
  Legend,
  Title,
  Tooltip,
  Corsair,
  Datalabels,
];

/* This plugins enabled only when they used in chart options */
export const optionalPlugins: Plugin[] = [LegendStatePlugin];

export type { ChartOptions, Plugin, PluginLegendItem } from './types.ts';
export { ChartLegend } from './legendStatePlugin/ChartLegend.tsx';
export { useTooltipShadowPlugin } from './useTooltipShadowPlugin.ts';
